import * as React from "react";
import styled from "styled-components";
import * as h from "../../_themes/helpers";

interface IProps {
  onUpdate: (value: number) => void;
  className?: string;
}

const RailView = ({ className, onUpdate }: IProps) => {
  const onClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const rect = (event.target as HTMLDivElement).getBoundingClientRect();
    const y = event.clientY - rect.top;
    onUpdate(((rect.height - y) / rect.height) * 100);
  };

  return <div className={className} onClick={onClick} />;
};

export const Rail = styled(RailView)`
  height: 100%;
  width: 0.3em;
  position: absolute;
  left: calc(50% - 0.15em);
  z-index: 1;
  background-color: ${h.getBackgroundColor(
    "sliderRailStyle",
    "slider.railStyle"
  )};
  cursor: pointer;
`;
